import type { TransferSeatColor } from '@/lib/api';

// Chair colours used everywhere a seat colour is rendered. `chair` is the
// stroke/fill class for the Armchair icon; `pill` is a matching background
// for the swatch buttons in the popover.
export const SEAT_COLOR_STYLE: Record<
  TransferSeatColor,
  { label: string; chair: string; pill: string; ring: string }
> = {
  gold: {
    label: 'Gold',
    chair: 'text-amber-400',
    pill: 'bg-amber-400',
    ring: 'ring-amber-300',
  },
  purple: {
    label: 'Purple',
    chair: 'text-purple-400',
    pill: 'bg-purple-500',
    ring: 'ring-purple-300',
  },
  blue: {
    label: 'Blue',
    chair: 'text-sky-400',
    pill: 'bg-sky-500',
    ring: 'ring-sky-300',
  },
  white: {
    label: 'White',
    chair: 'text-slate-100',
    pill: 'bg-slate-100',
    ring: 'ring-slate-300',
  },
};

export const SEAT_COLOR_ORDER: TransferSeatColor[] = ['gold', 'purple', 'blue', 'white'];
